import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import { decryptText } from "@/utils/cryptFunc";
import { storageGet, STORAGE_KEYS } from "@/services/storage.service";
import authRoutes from "./routes/authRoutes";
import teacherRoutes from "./routes/teacherRoutes";
import academyRoutes from "./routes/academyRoutes";
import adminRoutes from "./routes/adminRoutes";
import biRoutes from "./routes/biRoutes";
import hrRoutes from "./routes/hrRoutes";
import branchAcademyRoutes from "./routes/branchAcademyRoutes";
import callRoutes from "./routes/callRoutes";
import financeRoutes from "./routes/financeRoutes";
import marketingRoutes from "./routes/marketingRoutes";
import axoRoutes from "./routes/axoRoutes";
import moderatorRoutes from "./routes/moderatorRoutes";
import examinerRoutes from "./routes/examinerRoutes";
import instructorRoutes from "./routes/instructorRoutes";
import tutorRoutes from "./routes/tutorRoutes";
import kuratorRoutes from "./routes/kuratorRoutes";
import auditRoutes from "./routes/auditRoutes";
import metodistRoutes from "./routes/metodistRoutes";
import itIssuesRoutes from "./routes/itIssuesRoutes";
import statisticsRoutes from "./routes/statisticsRoutes";
import eventsRoutes from "./routes/eventsRoutes";

const routes = [
  ...authRoutes,
  ...teacherRoutes,
  ...academyRoutes,
  ...adminRoutes,
  ...biRoutes,
  ...hrRoutes,
  ...branchAcademyRoutes,
  ...callRoutes,
  ...financeRoutes,
  ...marketingRoutes,
  ...axoRoutes,
  ...moderatorRoutes,
  ...examinerRoutes,
  ...instructorRoutes,
  ...tutorRoutes,
  ...kuratorRoutes,
  ...auditRoutes,
  ...metodistRoutes,
  ...itIssuesRoutes,
  ...statisticsRoutes,
  ...eventsRoutes,
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach(async (to, from, next) => {
  // On first load, check if we're authenticated via HttpOnly cookie
  if (!store.state.auths._authChecked) {
    await store.dispatch("auths/checkAuth");
  }

  const requiredAuth = to.meta.auth;
  const userRole = decryptText(storageGet(STORAGE_KEYS.ROLE));
  const isSuperUser = storageGet(STORAGE_KEYS.SUPER_USER) || false;

  const isManager = storageGet(STORAGE_KEYS.IS_MANAGER) || false;

  // Clear PIN verification when leaving salary page
  if (from.meta.requiresPin && !to.meta.requiresPin) {
    sessionStorage.removeItem("salary_pin_verified");
  }

  // Block access to PIN-protected routes without verification
  if (to.meta.requiresPin && !sessionStorage.getItem("salary_pin_verified")) {
    next({ name: `${userRole}-main` });
    return;
  }

  // Block permission-flag routes (e.g. head_access)
  const PERMISSION_STORAGE_MAP = {
    head_access: STORAGE_KEYS.HEAD_ACCESS,
  };
  if (to.meta?.permission) {
    const storageKey = PERMISSION_STORAGE_MAP[to.meta.permission];
    const hasPermission =
      !!isSuperUser || (storageKey && storageGet(storageKey) === "true");
    if (!hasPermission) {
      next(userRole ? { name: `${userRole}-main` } : "/");
      return;
    }
  }

  if (
    !!isSuperUser ||
    (requiredAuth &&
      store.getters["auths/isAuth"] &&
      to.meta.role.includes(userRole) &&
      to.meta?.manager &&
      isManager)
  ) {
    next();
  } else if (
    requiredAuth &&
    store.getters["auths/isAuth"] &&
    userRole &&
    !to.meta.role.includes(userRole) &&
    isManager !== to.meta?.manager
  ) {
    next({ name: `${userRole}-main` });
  } else if (requiredAuth && !store.getters["auths/isAuth"]) {
    next("/");
  } else if (!to.meta.manager) {
    next();
  } else {
    next({ name: `${userRole}-main` });
  }
});
router.onError((error) => {
  if (error.name === "ChunkLoadError") {
    window.location.reload();
  }
});

export default router;
